import { Component, Injector } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UiStateService} from '../../../services/ui-state.service';
import {EventService} from "../../../services/event.service";
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
    selector: 'change-event-dialog',
    templateUrl: './change-event-dialog.component.html',
    styleUrls: ['./change-event-dialog.component.scss']
})
export class ChangeEventDialogComponent extends BaseDialogComponent {
    constructor(
        public activeModal: NgbActiveModal,
        public eventService: EventService,
        public uiStateService: UiStateService,
        injector: Injector
    ) {
        super(injector);
    }

    onEventSelect(event) {
        this.eventService.setEvent(event);
        this.activeModal.close();
    }
}
